/* eslint-disable */
import React from 'react';
import Modal from '../../component/Inc/Modal';
function PopMonthlyReport(props) {
  const {open, close} = props;
  return (
    <Modal open={open} close={close} type="pop_monthly_report">
      <h2 className="pop_tit">4주차 보고서</h2>
      <div className="content_container scroll">
        <div className="content_wrap">
          <section className="content_box scroll">
            <div className="com_info">
              <p className="name">김교사104</p>
              <span className="dot" />
              <p className="date">2023.05.20 11:30</p>
            </div>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="tit">학생명</span>
                  <span className="cont">
                    <button className="name btn_link">홍길동103 </button>
                    <span className="desc"> (고3ㆍ경기고등학교ㆍ본사) </span>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">수업 방법</span>
                  <span className="cont">대면</span>
                </div>
                <div className="info">
                  <span className="tit">수업 과목</span>
                  <span className="cont">과탐</span>
                </div>
                <div className="info">
                  <span className="tit">기수 / 타임</span>
                  <span className="cont">2기 / 2T</span>
                </div>
                <div className="info">
                  <span className="tit">담임</span>
                  <span className="cont">김담임132</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">수업 회차</span>
                  <span className="cont">(1회차 2023, 05, 10ㅣ12:30), (1회차 2023, 05, 10ㅣ12:30), (1회차 2023, 05, 10ㅣ12:30), (1회차 2023, 05, 10ㅣ12:30)</span>
                </div>
                <div className="info">
                  <span className="tit">수업변경 요청 횟수</span>
                  <span className="cont">0회</span>
                </div>
              </div>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="10%" />
                <col width="60%" />
                <col width="30%" />
              </colgroup>
              <thead>
                <tr>
                  <th colSpan={2}>학습 계획표</th>
                  <th>과제 이행도</th>
                </tr>
              </thead>
              <tbody>
                {[1, 2, 3, 4, 5].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <th>{idx + 1}주차</th>
                      <td className="td_left">
                        학습계획표 내용
                        <br />
                        학습계획표 내용
                      </td>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <div className="check">
                            <input type="radio" name="rdo" id={`rdo${idx}_${idx}`} className="com_chk circle" />
                            <label htmlFor={`rdo${idx}_${idx}`}>상</label>
                            <input type="radio" name="rdo" id={`rdo${idx}_${idx + 1}`} className="com_chk circle" />
                            <label htmlFor={`rdo${idx}_${idx + 1}`}>중</label>
                            <input type="radio" name="rdo" id={`rdo${idx}_${idx + 2}`} className="com_chk circle" />
                            <label htmlFor={`rdo${idx}_${idx + 2}`}>하</label>
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div className="com_input_wrap flex_between">
              <div className="detail_tit dot">학생 요청사항</div>
              <select name="" id="" className="select ws xs">
                <option value="없음">없음</option>
              </select>
            </div>
            <div className="com_board_box">
              <textarea name="" id="" className="textarea" placeholder="내용 입력 (학생 진도 및 수업관련 나아진 점, 20자 이상 필수 입력)"></textarea>
            </div>
            <div className="com_input_wrap flex_between">
              <div className="detail_tit dot">학부모 상담</div>
              <select name="" id="" className="select ws xs">
                <option value="미진행">미진행</option>
              </select>
            </div>
            <div className="com_board_box">
              <textarea name="" id="" className="textarea" placeholder="내용 입력 (학부모 주요상담 내용 및 학부모 반응, 20자 이상 필수 입력)"></textarea>
            </div>
          </section>
          <section className="content_box">
            <div className="detail_tit dot">학습 계획표</div>
            <table className="com_board_list week_list">
              <colgroup>
                <col width="89" />
                <col width="74" />
                <col width="74" />
                <col width="74" />
                <col width="74" />
                <col width="74" />
                <col width="74" />
                <col width="74" />
              </colgroup>
              <thead>
                <tr>
                  <th>진도및 과제</th>
                  <th>월</th>
                  <th>화</th>
                  <th>수</th>
                  <th>목</th>
                  <th>금</th>
                  <th>토</th>
                  <th>일</th>
                </tr>
              </thead>
              <tbody>
                {[...Array(5)].map((_, idx) => (
                  <tr key={idx}>
                    <th>{idx + 1}주차</th>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>
        </div>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">등록</button>
      </div>
    </Modal>
  );
}

export default PopMonthlyReport;
